module.exports = __webpack_public_path__ + "static/media/Nithesh-Padival.d21c33ac.svg";